import React, { useEffect, useRef } from "react";

import { ScrollArea } from "@picklebet/ui";
import { SharedEntryCard } from "@/features/share/components/SharedEntryCard";
import type { ProcessedEntry } from "@/hooks/firestore/betting/useEntries";

import * as styles from "./ShareEntryPreview.module.scss";

type ShareEntryPreviewProps = {
  entry: ProcessedEntry;
  isLoading: boolean;
};

export const ShareEntryPreview = ({
  entry,
  isLoading,
}: ShareEntryPreviewProps) => {
  const scrollAreaRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollAreaRef.current) {
      setTimeout(() => {
        scrollAreaRef.current!.scrollTo({
          top: 10000,
          behavior: "smooth",
        });
      }, 100);
    }
  }, []);

  return (
    <ScrollArea.Root className={styles.scrollArea} orientation="vertical">
      <ScrollArea.Viewport ref={scrollAreaRef} className={styles.viewport}>
        <div className={styles.preview}>
          <SharedEntryCard
            isCompact
            isPreview
            loading={isLoading}
            entry={entry}
          />
        </div>
      </ScrollArea.Viewport>
      <ScrollArea.ShadowStart className={styles.shadow} />
    </ScrollArea.Root>
  );
};
